import { render, staticRenderFns } from "./LanguageSettingsModal.vue?vue&type=template&id=56ef1ba2"
import script from "./LanguageSettingsModal.vue?vue&type=script&lang=js"
export * from "./LanguageSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports